export const shippingMethodProps = () => ({
  selected: {
    type: Boolean,
    required: false,
    default: false
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  infos: {
    type: Object,
    required: false
  },
  modeCommande: {
    type: Object,
    required: true
  },
  produitsIncompatibles: {
    type: Array,
    required: false
  },
  raisonsImpossible: {
    type: Array,
    required: false
  },
  typePanier: {
    type: String,
    required: false,
    default: null
  },
  isLadActif: {
    type: Boolean,
    required: false,
    default: false
  },
  montantManquantLad: {
    type: Number,
    required: false,
    default: null
  },
  lddDelaiLinkLabel: {
    type: String,
    required: false,
    default: null
  }
})

export const useShippingMethod = (props) => {
  const iconName = computed(() => {
    return getIconName(props.modeCommande.type_picto.code);
  })
  const description = computed(() => {
    return newlineToBr(props.modeCommande.description);
  })
  const hasFraisLiquide = computed(() => {
    return props.infos.frais_inclus && props.infos.frais_inclus.some(frais => frais.type === "SURPLUS LIQUIDES")
  })
  const isLC = computed(() => {
    return props.modeCommande.type === "LC"
  })
  const isDelipop = computed(() => {
    return props.modeCommande.type === "PRC_DELIPOP"
  })

  return { iconName, description, hasFraisLiquide, isLC, isDelipop }
}